import { ORIGINAL_BATTLE_MANIFEST } from "../data/generated/original-battle-manifest";

export const ORIGINAL_BATTLE_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-battle-manifest.json",
  generatedManifestModule: "web/src/data/generated/original-battle-manifest.ts",
  consumesDecodedBattle: true,
  sourceBackedStatus: ORIGINAL_BATTLE_MANIFEST.status,
  sourceBackedCriteria: {
    battleLoopDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.battleLoopDecoded,
    turnOrderDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.turnOrderDecoded,
    enemyActionDispatchDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.enemyActionDispatchDecoded,
    enemyActionDamageFormulaDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.enemyActionDamageFormulaDecoded,
    itemMagicEffectProceduresDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.itemMagicEffectProceduresDecoded,
    playerCommandHandlersDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.playerCommandHandlersDecoded,
    messageCommandEffectsDecoded: ORIGINAL_BATTLE_MANIFEST.criteria.messageCommandEffectsDecoded,
    specificFrmBattleHandlersReferenceOnly: ORIGINAL_BATTLE_MANIFEST.criteria.specificFrmBattleHandlersReferenceOnly,
    originalRuntimeBattleTraceScopedToPlaythroughGate:
      ORIGINAL_BATTLE_MANIFEST.criteria.originalRuntimeBattleTraceScopedToPlaythroughGate
  }
} as const;

export function originalBattleRuntimeConsumesDecodedBattle(): boolean {
  return ORIGINAL_BATTLE_RUNTIME_CONSUMPTION.consumesDecodedBattle;
}

export function originalBattlePlayerRawDamage(offense: number, defense: number): number {
  return Math.max(1, offense - defense);
}

export function originalBattleEnemyRawDamage(power: number, defense: number): number {
  return power - defense;
}

export function originalBattleEscapeFails(randomUnit: number): boolean {
  return randomUnit < 0.4;
}
